import { BaseLayout } from "./baseLayout"
import Big from "big.js"
import { isBefore, isThisSecond } from "date-fns"

export const AwiLeg = {
    props: ['data', 'preview'],
    mixins: [BaseLayout],
    data() {
        return {
            measures: {},
            panels: [],
            mpeIntervals: [],
            radioMPE: "mpeNormal"
        }
    },
    created() {
        this.debouncedSave = _.debounce(function() {
            // console.log('debouncedSave')
            if (!this.preview) {
                this.saveMeasures()
            }
        }, 1000)
    },
    watch: {
        measures: {
            deep: true,
            handler() {
                if (!this.preview) {
                    this.debouncedSave()
                }
            }
        }
    },
    methods: {
        handleCloseDialog() {
            this.tutorial_dialog.dialog = false;
        },
        handleUpdate(index, newData) {
            // console.log("$$ debug update", newData)
            if(this.measures.items[index]){
                this.measures.items[index].data = _.cloneDeep(newData)
                this.calculateBlockResult()
                this.checkPretestResult()
            }
        },
        checkPretestResult(){
            if(this.data.block.name == "pretest"){
                for(let item of this.measures.items){
                    if(!item.data || !item.data.result){
                        this.$parent.$emit('pretestResult', false, this.data.p_id)
                        return false
                    }
                }
                this.$parent.$emit('pretestResult', true, this.data.p_id)
            }
        },
        saveMeasures() {
            this.$parent.$emit('updateMeasure', { b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id })
        },
        calculateBlockResult(){
            let result = true
            for(let item of this.measures.items){
                if(item.data && item.data.result){
                    continue
                } else {
                    result = false
                    break
                }
            }
            if(result){
                this.measures.result = "done"
            } else {
                this.measures.result = "failed"
            }
        },
        async buildMeasures() {
            this.measures = {
                items: [],
                hi_res: "off",
                result: false
            }
            let categoryValues = await this.buildWithCategory()
            let formulas = this.data.block.formulas ? this.data.block.formulas : []
            if(categoryValues && categoryValues.length > 0){
                for(let i = 0; i < categoryValues.length; i++){
                    let stub = {
                        index: i,
                        data: null,
                        formulas: formulas,
                    }
                    if(this.isTare){
                        stub.tareBuilder = categoryValues[i]
                    } else {
                        stub.startValue = categoryValues[i]
                    }
                    this.measures.items.push(stub)
                }
            } else {
                for (let i = 0; i < this.data.block.conf.min_readings; i++){
                    let stub = {
                        index: i,
                        data: null,
                        startValue: null,
                        formulas: formulas
                    }
                    this.measures.items.push(stub)
                }
            }
        },
        deleteItem(item){
            let index = -1
            for(let i = 0; i < this.measures.items.length; i++){
                if(item.index == this.measures.items[i].index){
                    index = i
                    break
                }
            }
            if(index >= 0){
                this.measures.items.splice(index, 1)
            }
        }
    },
    computed: {
        isPretest(){
            if(this.data.block.name == "pretest"){
                return true
            } else {
                return false
            }
        },
        isTare(){
            if(this.data.block.name == "tare"){
                return true
            } else {
                return false
            }
        },
        primariesFilter(){
            if(this.data.primaries){
                let pippo =  this.data.primaries.filter(item => {
                    if(item.family == "bilancia nawi"){
                        return true
                    } else {
                        return false
                    }
                })
                return pippo
            } else {
                return []
            }
        },
    },
   

}